import { Controller } from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        field: String,
        tab: String,
    };

    editField(event) {
        if (window.matchMedia('(min-width: 1280px)').matches) {
            $('[href="' + this.tabValue + '"]').click();
        }

        const field = $('[data-field="' + this.fieldValue + '"]');

        $('html, body').animate({
            scrollTop: field.offset().top - $('.navbar-custom').height() - 20,
        }, 1000);

        field.find('[data-bs-toggle="edit"]').click();
    }
}
